import { FormFieldLabel } from "#components/ui/FormFieldLabel.tsx";
import type { UpdatePersonalizationForm } from "#features/personalization/hooks/useUpdatePersonalizationForm.ts";
import { useSharedTranslation } from "#hooks/useSharedTranslation.ts";
import { Flex, Switch } from "@hopper-ui/components";
import { useController, useFormContext } from "react-hook-form";

export const TrackingOptOutSwitch = () => {
    const { tShared } = useSharedTranslation();
    const { control } = useFormContext<UpdatePersonalizationForm>();
    const { field } = useController({ name: "trackingOptOut", control });

    return (
        <Flex direction="column" gap="inline-md">
            <FormFieldLabel tooltip={tShared("personalization.conversationSharingTooltip")}>
                <Switch
                    isSelected={!field.value}
                    onChange={value => field.onChange(!value)}
                >
                    {tShared("personalization.conversationSharingLabel")}
                </Switch>
            </FormFieldLabel>

        </Flex>
    );
};
